<template>
  <MainMenuViewLayout>
    <slot></slot>
  </MainMenuViewLayout>
</template>

<script>
import MainMenuViewLayout from './main-menu-view-layout/index.vue';

export default {
  components: { MainMenuViewLayout },
};
</script>
